// extracted by mini-css-extract-plugin
module.exports = {"blockHeading":"BlockHeading_blockHeading__V_zhe"};